import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcStackOfPhotos } from "react-icons/fc";
import FarmTraningFolderNew from "./folder_details_table";
import { FcCamcorderPro } from "react-icons/fc";
import ButtonWithSVG from "../../../Components/layouts/button_with_svg";

const GetFarmTranningFolders = () => {
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    performRequest("GET", `/farmmediadrive/folders`)
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data);
        } else {
          Toast("error", "Error while getting applications!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                     <FcCamcorderPro className="fs-2 me-1" />
                   Farm Training Folder List
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
                <div className="col-auto ms-auto d-print-none">
                  <div className="d-flex d-none d-sm-block">
                    <ButtonWithSVG
                      href={"/create-drive"}
                      buttonText="Create Drive"
                      svg={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          stroke="currentColor"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 5l0 14" />
                          <path d="M5 12l14 0" />
                        </svg>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                {/* <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Job type:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      jobType: e.target.value,
                                    })
                                  }
                                  value={filters.jobType}
                                >
                                  <option value="">select all</option>
                                  <option value="Internship">Internship</option>
                                  <option value="job">Job</option>
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Application Status:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      applicationStatus: e.target.value,
                                    })
                                  }
                                  value={filters.applicationStatus}
                                >
                                  <option value="">Select All</option>
                                  <option value="viewed">
                                    Profile Visited
                                  </option>
                                  <option value="shortlisted">
                                    Shortlisted
                                  </option>
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Employee type:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      Etype: e.target.value,
                                    })
                                  }
                                  value={filters.Etype}
                                >
                                  <option value="">Select</option>
                                  <option value="Fresher">Fresher</option>
                                  <option value="Experience">Experience</option>
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Departments:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      departments: e.target.value,
                                    })
                                  }
                                  value={filters.departments}
                                >
                                  <option value="">Select</option>
                                  <option value="Business Development">
                                    Business Development (Sales)
                                  </option>
                                  <option value="Operations Executive">
                                    Operations Executive (Purchase)
                                  </option>
                                  <option value="Social Media Marketing">
                                    Social Media Marketing (Video Editing,
                                    Graphic Design)
                                  </option>
                                  <option value="Human Resources">
                                    Human Resources
                                  </option>
                                  <option value="Accounting">Accounting</option>
                                  <option value="Management">Management</option>
                                  <option value="Agronomist">Agronomist</option>
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          jobType: "",
                                          Etype: "",
                                          departments: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Job type:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    jobType: e.target.value,
                                  })
                                }
                                value={filters.jobType}
                              >
                                <option value="">select all</option>
                                <option value="Internship">Internship</option>
                                <option value="job">Job</option>
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Employee type:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    Etype: e.target.value,
                                  })
                                }
                                value={filters.Etype}
                              >
                                <option value="">Select</option>
                                <option value="Fresher">Fresher</option>
                                <option value="Experience">Experience</option>
                              </DynamicFilterSelect>
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Departments:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    departments: e.target.value,
                                  })
                                }
                                value={filters.departments}
                              >
                                <option value="">Select</option>
                                <option value="Business Development">
                                  Business Development (Sales)
                                </option>
                                <option value="Operations Executive">
                                  Operations Executive (Purchase)
                                </option>
                                <option value="Social Media Marketing">
                                  Social Media Marketing (Video Editing, Graphic
                                  Design)
                                </option>
                                <option value="Human Resources">
                                  Human Resources
                                </option>
                                <option value="Accounting">Accounting</option>
                                <option value="Management">Management</option>
                                <option value="Agronomist">Agronomist</option>
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Application Status:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    applicationStatus: e.target.value,
                                  })
                                }
                                value={filters.applicationStatus}
                              >
                                <option value="">Select All</option>
                                <option value="viewed">Profile Visited</option>
                                <option value="shortlisted">Shortlisted</option>
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        jobType: "",
                                        Etype: "",
                                        departments: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                <div className="col-12 py-2">
                  <div className="card">
                    <FarmTraningFolderNew
                      data={data}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default GetFarmTranningFolders;
